import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private http = inject(HttpClient);
  private path = 'api/statistics';

  public getServicesCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/services/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getEnquiriesCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/enquiries/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getTasksCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/tasks/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getRfpsCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/rfps/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getWorkOrdersCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/work-orders/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getIncomingPaymentsCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/incoming-payments/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getBillsCountByStatus(filter: object = {}) {
    const endPoint = `${this.path}/bills/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getManagementTodos(filter: object = {}) {
    const endPoint = `${this.path}/todos/management`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getMyTodos(filter: object = {}) {
    const endPoint = `${this.path}/todos/my`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }

  public getCallCenterTicketCounts(filter: object = {}) {
    const endPoint = `${this.path}/call-center/count-by-status`;
    const params: any = Object.assign({}, filter);
    return this.http.get(endPoint, { params });
  }
}
